import React from 'react';
import { ProfilePicture } from '../../ui/ProfilePicture';
import { Employee } from '../../interfaces/interface';
import { formatEmployeeDetails } from '../../utils/employeeUtils';
import './EmployeeListItem.scss';

interface EmployeeListItemProps {
  employee: Employee;
  onClick?: () => void;
  showDetails?: boolean;
  disabled?: boolean;
  disableHover?: boolean;
  renderActions?: () => React.ReactNode;
  className?: string;
}

export const EmployeeListItem: React.FC<EmployeeListItemProps> = ({
  employee,
  onClick,
  showDetails = true,
  disabled = false,
  disableHover = false,
  renderActions,
  className = ''
}) => {
  const handleClick = () => {
    if (!disabled && onClick) {
      onClick();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (!disabled && onClick && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      onClick();
    }
  };

  const containerClassName = disabled
    ? 'employee-item hoverable-row--disabled'
    : onClick && !disableHover
    ? 'employee-item hoverable-row'
    : 'employee-item';
  const displayName = employee.displayName || employee.employee_name;
  const employeeDetails = showDetails && employee ? formatEmployeeDetails(employee) : '';

  return (
    <div
      className={`${containerClassName} ${className}`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      tabIndex={disabled ? -1 : onClick ? 0 : undefined}
      role={onClick ? 'button' : undefined}
      aria-disabled={disabled}
    >
      <div className="employee-info-container">
        <ProfilePicture loginName={employee.login_name} name={displayName} size="small" />
        <div className="employee-name-wrapper">
          <div className="employee-name-line">
            <span className="employee-name-text">{displayName}</span>
            {employee.login_name && <span className="employee-email-text"> ({employee.employee_internal_email_address})</span>}
          </div>
          {showDetails && employee && employeeDetails && (
            <div className="employee-details-text" title={employeeDetails}>
              {employeeDetails}
            </div>
          )}
        </div>
      </div>
      {renderActions && <div className="employee-item-actions">{renderActions()}</div>}
    </div>
  );
};
